import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'
import { IProject } from '../projects.types'
import eventsSelectors from 'screens/Admin/Events/events.selectors'
import selfProjectsAtom from 'screens/Auth/components/InitProvider/selfProjects.atom'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'

const useIsLeaveProjectPossible = (project: Pick<IProject, 'id' | 'eventId'>) => {

  const selfProjects = useRecoilValue(selfProjectsAtom).items

  const selfId = useRecoilValue(authAtom).user.id

  const selfTeams = useRecoilValue(selfTeamsAtom).items
  const activeTeam = selfTeams[0]

  const eventsMap = useRecoilValue(eventsSelectors.eventsFullMap)
  const isSelfProject = !!selfProjects.find(sp => sp.id === project.id)
  const event = eventsMap[project.eventId]

  return isSelfProject && activeTeam?.ownerId === selfId && !event.locked
}

export default useIsLeaveProjectPossible
